import { useTranslation } from 'react-i18next'

import {
  RentalPortalProfileHeaderFooterActionButton,
  RentalPortalProfileHeaderFooterAddNewText,
  RentalPortalProfileHeaderFooterHiddenMeasureLayer,
  RentalPortalProfileHeaderFooterMoreButton,
} from '../../RentalPortalProfileHeaderFooter'

import {
  QA_NAME_VIEWING_PROFILE_FOOTER_ADD_NEW,
  QA_NAME_VIEWING_PROFILE_FOOTER_MORE,
} from './RentalPortalViewingProfileHeaderFooter.constants'
import { useViewingProfileHeaderFooter } from './RentalPortalViewingProfileHeaderFooter.hooks'
import { getViewingProfileFooterMoreOptions } from './RentalPortalViewingProfileHeaderFooter.utils'

import * as styles from './RentalPortalViewingProfileHeaderFooter.module.css'

function RentalPortalViewingProfileHeaderFooter() {
  const { t } = useTranslation()

  const {
    actionHandlers,
    addNewTextMeasureRef,
    addNewTextRef,
    getActionButtonRef,
    handleContainerRef,
    handleSelectMoreOption,
    hasActions,
    hiddenActions,
    moreButtonMeasureRef,
    visibleActions,
  } = useViewingProfileHeaderFooter()

  return hasActions ? (
    <div className={styles.footer}>
      <div className={styles.container} ref={handleContainerRef}>
        <div className={styles.bar}>
          <div className={styles.addNewTextWrapper} ref={addNewTextRef}>
            <RentalPortalProfileHeaderFooterAddNewText
              qaName={QA_NAME_VIEWING_PROFILE_FOOTER_ADD_NEW}
            />
          </div>
          {visibleActions.map(
            ({ Icon, action, disabled, qaName, text, tooltipKey }) => (
              <RentalPortalProfileHeaderFooterActionButton
                Icon={Icon}
                disabled={disabled}
                key={action}
                qaName={qaName}
                text={text}
                tooltipKey={tooltipKey}
                wrapperRef={getActionButtonRef(action)}
                onClick={actionHandlers[action]}
              />
            )
          )}
          {hiddenActions.length > 0 ? (
            <RentalPortalProfileHeaderFooterMoreButton
              className={styles.moreButton}
              options={getViewingProfileFooterMoreOptions({
                actions: hiddenActions,
                t,
              })}
              qaName={QA_NAME_VIEWING_PROFILE_FOOTER_MORE}
              onSelectItem={handleSelectMoreOption}
            />
          ) : null}
        </div>
        <RentalPortalProfileHeaderFooterHiddenMeasureLayer
          addNewTextMeasureRef={addNewTextMeasureRef}
          moreButtonMeasureRef={moreButtonMeasureRef}
        />
      </div>
    </div>
  ) : null
}

export default RentalPortalViewingProfileHeaderFooter
